import { Component } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { SharedStore } from '../../core/providers/shared';



@Component({
	selector:		'section[page-404]',
	templateUrl:	'404.html',
})
export class NotFoundComponent {
	constructor(
		public shared: SharedStore,
		public angulartics2: Angulartics2,
	) {
		this.shared.page = '404';
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/404/404.ts